export const routes = [
  {
    path: '/categorias',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'categorias.list',
    meta: {
      requiresAuth: true
    }
  }
]
